module.exports = __webpack_public_path__ + "static/media/welcome-2-bg.4af5c1fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/App/welcome-2-bg.jpg
// module id = 133
// module chunks = 0